import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25d58eb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Колонка", -1))
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Значение", -1))
const _hoisted_6 = { style: {"margin":"12px"} }
const _hoisted_7 = { class: "DataFillDialog-checkbox" }
const _hoisted_8 = { class: "DataFillDialog-checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_CheckBoxControl = _resolveComponent("CheckBoxControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createBlock(_component_DxPopup, {
    visible: _ctx.popupVisible,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.popupVisible) = $event)),
    "drag-enabled": true,
    "close-on-outside-click": false,
    "show-title": true,
    width: 600,
    height: 305,
    shading: true,
    resizeEnabled: true,
    title: "Заполнение данных",
    onContentReady: _ctx.onContentReady
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DxScrollView, {
        width: "100%",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_DxSelectBox, {
                class: "ModelField-control",
                items: _ctx.columns,
                value: _ctx.selectedColumn,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedColumn) = $event)),
                onValueChanged: _ctx.onColumnValueChanged,
                displayExpr: 'caption',
                stylingMode: "outlined"
              }, null, 8, ["items", "value", "onValueChanged"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.isTextControl)
                ? (_openBlock(), _createBlock(_component_TextControl, {
                    key: 0,
                    class: "ModelField-control",
                    value: _ctx.columnValue,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.columnValue) = $event)),
                    stylingMode: "outlined"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.isIntegerControl)
                ? (_openBlock(), _createBlock(_component_IntegerControl, {
                    key: 1,
                    class: "ModelField-control",
                    value: _ctx.columnValue,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.columnValue) = $event)),
                    stylingMode: "outlined"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.isDecimalControl)
                ? (_openBlock(), _createBlock(_component_DecimalControl, {
                    key: 2,
                    class: "ModelField-control",
                    value: _ctx.columnValue,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.columnValue) = $event)),
                    decimalPoints: _ctx.selectedColumn.decimalPoints,
                    stylingMode: "outlined"
                  }, null, 8, ["value", "decimalPoints"]))
                : _createCommentVNode("", true),
              (_ctx.isDateControl)
                ? (_openBlock(), _createBlock(_component_DateControl, {
                    key: 3,
                    class: "ModelField-control",
                    value: _ctx.columnValue,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.columnValue) = $event)),
                    stylingMode: "outlined",
                    mode: "datetime"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.isCatalogueControl)
                ? (_openBlock(), _createBlock(_component_CatalogueSelectControl, {
                    key: 4,
                    class: "ModelField-selectControl",
                    stylingMode: "outlined",
                    id: _ctx.columnValue,
                    "onUpdate:id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.columnValue) = $event)),
                    desc: _ctx.catalogueDescription,
                    "onUpdate:desc": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.catalogueDescription) = $event)),
                    displayDescField: "name",
                    keyField: "id",
                    catalogueComponentName: _ctx.cataloguePath,
                    hasEmptyValue: false,
                    validationGroup: "dataFillValidationGroup"
                  }, null, 8, ["id", "desc", "catalogueComponentName"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.isCheckBoxControl)
                  ? (_openBlock(), _createBlock(_component_CheckBoxControl, {
                      key: 0,
                      value: _ctx.columnValue,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.columnValue) = $event))
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DxCheckBox, {
              value: _ctx.changeNonEmpty,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.changeNonEmpty) = $event)),
              text: "Заменять непустые ячейки"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DxCheckBox, {
              value: _ctx.changeEmpty,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.changeEmpty) = $event)),
              text: "Заменять пустые ячейки"
            }, null, 8, ["value"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DxToolbarItem, {
        options: _ctx.okButtonOptions,
        widget: "dxButton",
        location: "after",
        toolbar: "bottom"
      }, null, 8, ["options"]),
      _createVNode(_component_DxToolbarItem, {
        options: _ctx.cancelButtonOptions,
        widget: "dxButton",
        location: "after",
        toolbar: "bottom"
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["visible", "onContentReady"]))
}